export class ListaAtendimento {
  itens: ItemAtendimento[] = [];
}

export class ItemAtendimento{
  id: number;
  descricao: string;
  dataCadastro: Date;
  dataModificacao: Date;
  solicitante: string;
  solicitanteEmail: string;
  solicitanteTelefone: string;
  descricaoResumida: string;
  statusDescricao: string;
  status: number;
  valor: number;
}
